import { Component, computed, input, output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { AIRT_SCANS_KEY, DDOS_FILTER_KEY, DNS_FIREWALL_KEY } from "./cert-tabs.constants";

@Component({
  selector: "cert-tabs",
  templateUrl: "cert-tabs.html",
  styleUrls: ["cert-tabs.scss"],
  imports: [TranslateModule],
})
export class CertTabs {
  readonly activeTab = input.required<string>();

  scanActive = computed(() => this.activeTab() === AIRT_SCANS_KEY);
  ddosActive = computed(() => this.activeTab() === DDOS_FILTER_KEY);
  dnsFirewallActive = computed(() => this.activeTab() === DNS_FIREWALL_KEY);
  tabEmitter = output<string>();

  changeToAirtScansTab = () => this.tabEmitter.emit(AIRT_SCANS_KEY);
  changeToDdosFilterTab = () => this.tabEmitter.emit(DDOS_FILTER_KEY);
  changeToDnsFirewallTab = () => this.tabEmitter.emit(DNS_FIREWALL_KEY);
}
